import trans from '../../helpers/trans';
import { SkillsFormData } from '../../models/@competentNL/Skills/Skills';
import { isFetchResultSuccessful } from '../../models/FetchResult';
import { putCandidateSkillsApiCall } from '../../models/Skills/SkillsService';
import { setSkillsIsSuccessful } from '../competentNL/competentNL';
import { setCareerSkills } from '../skillsPassport/skillsPassport';
import { TypedDispatch } from '../store';
import { setError, setIsSuccessful, setIsUpdating } from './skills';

export const updateCandidateSkills = (formData: SkillsFormData, candidateUuid: string) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsUpdating(true));
    dispatch(setError(''));

    try {
        const skillIds = formData.skills.map(skill => skill.id);

        const skillsPassportResponse = await putCandidateSkillsApiCall(skillIds, candidateUuid);

        if (!isFetchResultSuccessful(skillsPassportResponse)) {
            dispatch(setError(trans('errors.unknownError')));
            return;
        }

        dispatch(setCareerSkills(skillsPassportResponse.data));

        dispatch(setIsSuccessful(true));
        dispatch(setSkillsIsSuccessful(true));
    } catch (error) {
        console.error('[updateCandidateSkills]', error);
    } finally {
        dispatch(setIsUpdating(false));
    }
};
